import { Link } from '@sortlist-frontend/design-system';

import type { RankingCompactAgency } from '../types';
import { agencyProfilePath } from '../utils/agencyProfilePath';
import { AgencyLogo } from './AgencyLogo';
import { AgencyMetaRow } from './AgencyMetaRow';
import { RankingCard } from './RankingCard';

interface CompactAgencyCardProps {
  agency: RankingCompactAgency;
  locale: string;
}

export const CompactAgencyCard = (props: CompactAgencyCardProps) => {
  const { agency, locale } = props;

  return (
    <RankingCard className="flex h-full flex-col p-5">
      <div className="flex items-center gap-3">
        <AgencyLogo src={agency.logoUrl} name={agency.name} size="sm" />
        <h3 className="min-w-0 break-words text-lg font-semibold text-secondary-950">
          <Link href={agencyProfilePath(agency.slug)} color="foreground" underline="hover">
            {agency.name}
          </Link>
        </h3>
      </div>
      <div className="mt-3">
        <AgencyMetaRow agency={agency} locale={locale} isCompact />
      </div>
      <p className="mt-3 text-sm leading-relaxed text-secondary-700">{agency.description}</p>
    </RankingCard>
  );
};
